export default [
    {
        path: '/',
        name: 'Login',
        component: () => import('../../views/auth/Login.vue')
    },
]